// extracted by mini-css-extract-plugin
export var skipAnimation = "_w-0";